import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {ExpandMore} from "@mui/icons-material";
import {useRecoilValue} from "recoil";
import {raDetailState} from "../state";

const RenewalsFromExtension = () => {
    const theme = useTheme();
    const {t} = useTranslation(['network']);
    const raDetail = useRecoilValue(raDetailState);

    const url = '/network/ra-detail/';

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Typography variant={"bodyLarge"}>
                    {t("raDetail.renewalsFromExtension.accordion.title")}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                {
                    raDetail?.renewalInfo
                        .map((ra: any) => {
                            return <Box sx={{my: theme.spacing(2)}}>
                                <Box>
                                    <Link to={`${url}${ra.idRentalAgreement}`} target="_blank"
                                          style={{textDecoration: 'none'}}>
                                        <Typography variant={'body'}>
                                            {ra.idRentalAgreement}
                                        </Typography>
                                    </Link>
                                </Box>
                                {
                                    ra.idsRentalAgreementSubstitution
                                        .map((sub: any) =>
                                            <Box sx={{ml: theme.spacing(2), my: theme.spacing(1)}}>
                                                <Link to={`${url}${sub}`} target="_blank"
                                                      style={{textDecoration: 'none'}}>
                                                    <Typography variant={'body'}>
                                                        - {sub}
                                                    </Typography>
                                                </Link>
                                            </Box>
                                        )
                                }
                            </Box>
                        })
                }
            </AccordionDetails>
        </Accordion>
    )
}

export default RenewalsFromExtension;